var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#clip0_1066_2093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9243 10.4401C12.0182 9.66506 11.0986 9.1956 10.2035 9.96945L9.6691 10.4372C9.27808 10.7767 8.55105 12.363 5.74013 9.12945C2.92979 5.89999 4.60218 5.39716 4.99379 5.06057L5.53115 4.59228C6.42149 3.81667 6.08549 2.84028 5.44335 1.83521L5.05584 1.22643C4.41076 0.223695 3.70832 -0.434842 2.81564 0.339597L2.3333 0.761061C1.93876 1.04848 0.835932 1.98272 0.56842 3.75755C0.246469 5.88711 1.26208 8.32574 3.58891 11.0015C5.91281 13.6783 8.18813 15.0229 10.3434 14.9995C12.1347 14.9802 13.2164 14.019 13.5548 13.6695L14.0389 13.2475C14.9292 12.4736 14.376 11.6857 13.4693 10.909L12.9243 10.4401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_2093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c8e21a7131494960d27840dccaebfe37.svg";
export { ForwardRef as ReactComponent };